import { createSharedPromise, errorWithoutStack } from '@/common';
// import { AxiosError, type InternalAxiosRequestConfig } from 'axios';
import type { InternalAxiosRequestConfig } from 'axios';

const jwtShared = createSharedPromise(() => useClientStore().refreshJwtToken());

export const jwtServiceInterceptor = async (config: InternalAxiosRequestConfig) => {
    const clientStore = useClientStore();

    if (!config.headers.hasAccept) {
        config.headers.Accept = 'application/json';
    }

    //todo -- use shared promise for refreshing JWT
    // const expired = clientStore.isJwtExpired();
    // if (expired) {
    //     if (clientStore.auth.sessionToken == null) {
    //         console.warn('NO_SESSION_TOKEN: please login.');
    //         return config;
    //     }
    //     try {
    //         await jwtShared.resolveTo();
    //         console.log('AUTO_REFRESH_JWT: success');
    //         if (clientStore.jwtClaims == null) {
    //             //did not get jwt
    //             return config;
    //         }
    //     } catch (e) {
    //         console.error('AUTO_REFRESH_JWT: failure');
    //         if (e instanceof AxiosError) {
    //             if (e.response?.status === 401 || e.response?.status === 404) {
    //                 console.log('Invalid session token. Removing it from store.');
    //                 clientStore.auth.sessionToken = undefined;
    //             } else {
    //                 console.error('Unknown error when refreshing JWT token.', errorWithoutStack(e));
    //             }
    //             return config;
    //         }
    //     }
    // }
    if (clientStore.auth.jwt) {
        config.headers.Authorization = 'Bearer ' + clientStore.auth.jwt;
    }
    return config;
};
